import React, { useEffect } from "react";
import {
  Route,
  Routes,
  Navigate,
  useLocation,
  BrowserRouter,
} from "react-router-dom";
import AppLayout from "./components/Applayout";
import Home from "./features/Dashboard/Home";
import Client from "./features/Client/Client";
import Lead from "./features/Lead/Lead";
import AddNewLead from "./features/Lead/AddNewLead";
import Messenger from "./features/Messenger/Messenger";
import Toolbox from "./features/Toolbox/Toolbox";
import LatestUpdate from "./features/LatestUpdate/LatestUpdate";
import Login from "./components/Login";
import EmailWriter from "./components/EmailWriter";
import AddOfferDetail from "./features/Lead/AddOfferDetail";
import ProfileSettings from "./features/Setting/ProfileSettings";
import Settings from "./features/Setting/Setting";
import EditLead from "./features/Lead/EditLead";
import ClientSideBar from "./features/Client/ClientSideBar";
import ConfirmationPage from "./components/ConfirmationPage";
import WorkoutTemplateBuilder from "./features/Toolbox/WorkoutTemplateBuilder";

import Loader from "./components/Common/Loader";
import StripeCoachSuccess from "./components/StripeCoachSuccess";
import StripeCoachCancel from "./components/StripeCoachCancel";
import StripeClientSuccess from "./components/StripeClientSuccess";
import StripeClientCancel from "./components/StripeClientCancel";
import CoachConfirmationPage from "./components/CoachConfirmationPage";
import OnboardClientSuccess from "./components/OnboardClientSuccess";
import CoachCardUpdateConfirmation from "./components/CoachCardUpdateConfirmation";
import CoachOnboardConfirmation from "./components/CoachOnboardConfirmation";
import StripeCoachOnboard from "./components/StripeCoachOnboard";
import CoachOnboardSuccess from "./components/CoachOnboardSuccess";
import Recipe from "./features/Recipe/Recipe";
import RecipeSaveSuccess from "./features/Recipe/RecipeSaveSuccess";
import PrivacyPolicy from "./components/Common/PrivacyPolicy";
import PaymentMethodSuccess from "./components/PaymentMethodSuccess";

// Create a wrapper component to handle the query params
const LoginWrapper = ({ login }) => {
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const coachEmail = searchParams.get("coachemail");
    if (coachEmail) {
      localStorage.setItem("coachemail", coachEmail);
    }
  }, [location.search]);

  return <Login login={login} />;
};

const RoutesComponent = ({ isAuthenticated, login, logout, loading }) => {
  if (loading) {
    return <Loader />;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route
          path="/confirmationPage/:leadOfferDetailsId"
          element={<ConfirmationPage />}
        />
        <Route
          path="/coach/confirmationPage/:leadOfferDetailsId"
          element={<CoachConfirmationPage />}
        />
        <Route
          path="/confirmationPage/coach/success"
          element={<StripeCoachSuccess />}
        />
        <Route
          path="/confirmationPage/coachOnboard/:offerID"
          element={<StripeCoachOnboard />}
        />
        <Route
          path="/confirmationPage/coachOnboard/onboardsuccess"
          element={<CoachOnboardSuccess />}
        />
        <Route
          path="/confirmationPage/coach/cancel"
          element={<StripeCoachCancel />}
        />
        <Route
          path="/confirmationPage/client/success"
          element={<StripeClientSuccess />}
        />
        <Route
          path="/confirmationPage/client/cancel"
          element={<StripeClientCancel />}
        />
        <Route
          path="/confirmationPage/client/Onboard/success"
          element={<OnboardClientSuccess />}
        />
        <Route
          path="/confirmationPage/coachOnboard/success"
          element={<CoachOnboardConfirmation />}
        />
        <Route
          path="/confirmationPage/coachCardUpdate/success"
          element={<CoachCardUpdateConfirmation />}
        />
         <Route
          path="/confirmationPage/client/paymentmethodsuccess"
          element={<PaymentMethodSuccess />}
        />
        {!isAuthenticated ? (
          <>
            <Route path="/login" element={<LoginWrapper login={login} />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </>
        ) : (
          <Route element={<AppLayout logout={logout} />}>
            <Route path="/dashboard" element={<Home logout={logout} />} />
            <Route path="/clients" element={<Client />} />
            <Route path="/clients/clientDetails" element={<ClientSideBar />} />
            <Route path="/leads" element={<Lead />} />
            <Route path="/leads/addNewLead" element={<AddNewLead />} />
            <Route
              path="/leads/addNewOffer/:leadId?"
              element={<AddOfferDetail />}
            />
            <Route path="/leads/editLead/:id" element={<EditLead />} />
            <Route path="/messenger" element={<Messenger />} />
            <Route path="/toolbox" element={<Toolbox />} />
            <Route
              path="/toolbox/builder"
              element={<WorkoutTemplateBuilder />}
            />
            <Route path="/updates" element={<LatestUpdate />} />
            <Route path="/recipe" element={<Recipe />} />
            <Route path="/recipe-success" element={<RecipeSaveSuccess />} />
            <Route path="/emailWriter" element={<EmailWriter />} />
            <Route path="/profile-settings" element={<ProfileSettings />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Route>
        )}
      </Routes>
    </BrowserRouter>
  );
};

export default RoutesComponent;
